<template>
	<section>
		<painel-shell>
			<template v-slot:header-left>
				<navigation-header :title="$t('base.general.patients')" subtitle="We care about your well-being."></navigation-header>
			</template>
			<header-simple :space-top="false" :title="$t('base.general.patients')" :subtitle="'Information about the patients.'">
				<action-button :title="$t('buttons.actions.add_patient')" @click="onButtonClick(TYPE_PATIENT)" />
				<action-group :has-button="true">
					<action-group-item-button @click="onButtonClick(TYPE_GROUP)" :title="$t('buttons.actions.add_group')" />
				</action-group>
			</header-simple>
			<user-watches-patients-list :user_uid="user_uid" />
		</painel-shell>
		<modal-box v-if="modalBox.open" @close="onModalBoxClose" :header="modalBox.title" :subHeader="$t('base.general.patients')">
			<form-group   v-if="isModalType(TYPE_GROUP)"   @done="onFormDone" :user_uid="user_uid" :action="modalBox.action" :group_id="modalBox.model_id" :type="groupFormType"/>
			<form-patient v-if="isModalType(TYPE_PATIENT)" @done="onFormDone" :user_uid="user_uid" :action="modalBox.action"/>
		</modal-box>
	</section>
</template>

<script>
import UserWatchesPatientsList from './watches/UserWatchesPatientsList'
import HeaderSimple from '@/modules/ui/HeaderSimple'
import NavigationHeader from '@/components/navigation/NavigationHeader'
import PainelShell from '@/modules/shell/PainelShell'
import FormTypes from './watches/FormTypes'
import FormGroup from './watches/UserWatchesFormGroup'
import FormPatient from './watches/UserWatchesFormPatient'
import FormDevice from './watches/UserWatchesFormDevice'
import ActionButton from '@/modules/ui/ActionButton'
import ActionGroup from '@/modules/ui/ActionGroup'
import ActionGroupItemLink from '@/modules/ui/ActionGroupItemLink'
import ActionGroupItemButton from '@/modules/ui/ActionGroupItemButton'

export default {
	components: {
		PainelShell,
		FormGroup,
		FormPatient,
		FormDevice,
		NavigationHeader,
		HeaderSimple,
		UserWatchesPatientsList,
		ActionGroup,
		ActionGroupItemLink,
		ActionGroupItemButton,
		ActionButton
	},
	props: [
		'user_uid'
	],
	data () {
		return {
			TYPE_GROUP: FormTypes.GROUP,
			TYPE_PATIENT: FormTypes.PATIENT,
			modalBox: {
				open: false,
				action: '',
				model_id: '',
				type: '',
				title: ''
			}
		}
	},
	computed: {
		groupFormType () {
			return FormTypes.PATIENT
		},
	},
	methods: {
		onButtonClick (type) {
			let open = true
			let action = 'add'
			switch (type) {
				case this.TYPE_GROUP:
					this.modalBox.title = this.$t('buttons.actions.add_group')
					break
				case this.TYPE_PATIENT:
					this.modalBox.title = this.$t('buttons.actions.add_patient')
					break
				default:
					action = ''
					type = null
					open = false
			}
			this.modalBox.action = action
			this.modalBox.type = type
			this.modalBox.open = open
		},
		onEditGroup (group_id) {
			this.modalBox.action = 'edit'
			this.modalBox.model_id = group_id
			this.modalBox.type = this.TYPE_GROUP
			this.modalBox.title = this.$t('buttons.actions.edit_group')
			this.modalBox.open = open
		},
		onModalBoxClose () {
			this.modalBox.action = ''
			this.modalBox.model_id = ''
			this.modalBox.type = ''
			this.modalBox.title = ''
			this.modalBox.open = false
		},
		onFormDone () {
			this.onModalBoxClose()
			this.$store.dispatch('GET_PATIENTS', this)
		},
		isModalType (type) {
			return this.modalBox.type === type
		}
	},
	created () {
		this.$root.$on('editGroup', this.onEditGroup)
	},
	beforeDestroy () {
		this.$root.$off('editGroup', this.onEditGroup)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/UserWatches.vue